import ResourceService from './resource.service'

class ReligionService extends ResourceService {
  static get resource() {
    return 'religion'
  }
}

export default ReligionService
